import moment from 'moment-timezone';

export const ADDRESS_CHECK_RESULTS = Object.freeze({
  NOT_CHECKED: 'NOT_CHECKED', UNCHANGED: 'UNCHANGED', NORMALIZED: 'NORMALIZED',
  CORRECTED: 'CORRECTED', NO_RESULT: 'NO_RESULT', LOOKUP_FAILED: 'LOOKUP_FAILED'
});
export const NUMBER_TYPE = Object.freeze({ WAYBILL: 1, ORDER: 2, CUSTOMER: 3 });
export const ORDER_LOG_STATE = Object.freeze({ SUCCESS: 1, FAILURE: 0 });
const BUSINESS_ZONE = 'America/Sao_Paulo';
const FORMAT = 'YYYY-MM-DD HH:mm:ss';
const DAY = 86400000;

export function defaultOrderLogDates(now = new Date()) {
  const end = moment(now).tz(BUSINESS_ZONE);
  return [
    end.clone().subtract(30, 'days').startOf('day').format(FORMAT),
    end.clone().endOf('day').format(FORMAT)
  ];
}

export function validateOrderLogDates(dates, now = new Date()) {
  if (!dates || !dates.length) return null;
  if (dates.length !== 2 || !dates[0] || !dates[1]) return 'invalidTime';
  const start = moment.tz(dates[0], FORMAT, true, BUSINESS_ZONE);
  const end = moment.tz(dates[1], FORMAT, true, BUSINESS_ZONE);
  if (!start.isValid() || !end.isValid()) return 'invalidTime';
  if (start.valueOf() > end.valueOf()) return 'reversedTime';
  if (start.valueOf() > now.valueOf()) return 'futureStart';
  if (end.valueOf() - start.valueOf() > 31 * DAY) return 'max31Days';
  if (start.valueOf() < now.valueOf() - 180 * DAY) return 'max180Days';
  return null;
}

export function buildOrderLogParams(form, batchNumbers) {
  const numbers = form.number.trim() ? [form.number.trim()] : [...batchNumbers];
  const params = {
    orderNumberList: [], logisticsNumberList: [], customerNumberList: [],
    startTime: form.dates && form.dates.length ? form.dates[0] : '',
    endTime: form.dates && form.dates.length ? form.dates[1] : '',
    customerId: form.customerId, state: form.state,
    receiveAddressCheckResult: form.receiveAddressCheckResult
  };
  const field = {
    [NUMBER_TYPE.WAYBILL]: 'logisticsNumberList',
    [NUMBER_TYPE.ORDER]: 'orderNumberList',
    [NUMBER_TYPE.CUSTOMER]: 'customerNumberList'
  }[form.numberType];
  params[field] = numbers;
  return params;
}

export function addressCheckLabel(value, translate) {
  const key = !value ? 'unrecorded'
    : Object.values(ADDRESS_CHECK_RESULTS).includes(value) ? value : 'unknown';
  return translate('orderLogAddress.' + key);
}

export function addressCheckTagType(value) {
  return {
    [ADDRESS_CHECK_RESULTS.CORRECTED]: 'warning',
    [ADDRESS_CHECK_RESULTS.UNCHANGED]: 'success',
    [ADDRESS_CHECK_RESULTS.LOOKUP_FAILED]: 'danger'
  }[value] || 'info';
}

export function formatOrderLogRecords(records) {
  const fields = ['requestParams', 'responseParams', 'originalRequestParams',
    'originalResponseParams', 'dealedRequestParams', 'dealedResponseParams'];
  return records.map((record) => {
    const row = { ...record };
    fields.forEach((field) => {
      if (row[field]) {
        try {
          row[field] = JSON.stringify(JSON.parse(row[field]), null, 2);
        } catch (error) {
          // 非 JSON 的历史报文保留原文本，不因单条记录解析失败丢掉整页。
          row[field] = record[field];
        }
      }
    });
    return row;
  });
}
